import { useState } from "react";
import { useDispatch } from "react-redux";
import { setNotification } from "features/Notification/notificationSlice";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function ExportProductPngs({
  selectedWO,
  btnClasses,
  onLoadingChange,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const setLoadingState = (val) => {
    setLoading(val);
    onLoadingChange?.(val);
  };

  const handleExport = async () => {
    if (!selectedWO?.woId) return;
    try {
      setLoadingState(true);
      const response = await API.get(`/download-images/${selectedWO.id}`, {
        headers: authHeader(),
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `WO-${selectedWO.woId}-products.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message || "Failed to export product images.",
          type: "error",
        }),
      );
    } finally {
      setLoadingState(false);
    }
  };

  return (
    <button
      type="button"
      disabled={loading}
      onClick={handleExport}
      className={btnClasses || "btn w-100 text-start text-nowrap"}
    >
      {loading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-1"
            role="status"
          />
          Exporting...
        </>
      ) : (
        "Export Product PNGs"
      )}
    </button>
  );
}
